import {Action, getModule, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {
  HT移動一括取込フラグ型,
  HT払出一括取込フラグ型,
  システム利用区分型,
  バラ管理フラグ型,
  ログインアカウント型,
  備蓄品採用フラグ型,
  外部連携利用フラグ型,
  有効期限管理フラグ型,
  棚卸有効期限非表示フラグ型,
  権限レベル区分型,
  独自コード利用フラグ型,
  独自区分利用フラグ型,
  発注書自動表示フラグ型,
  譲渡譲受利用フラグ型,
} from '@/type/authentication/login';
import api from '@/infrastructure/api/api';
import store from '@/store';

@Module({dynamic: true, store, name: 'login', namespaced: true})
class Login extends VuexModule {
  private ログインアカウント: ログインアカウント型 = {
    医療機関コード: '',
    部署コード: '',
    部署名: '',
    利用者コード: '',
    氏名: '',
    権限レベル区分: 権限レベル区分型.利用者,
    システム利用区分: システム利用区分型.発注のみ,
    備蓄品採用フラグ: 備蓄品採用フラグ型.無効,
    発注書自動表示フラグ: 発注書自動表示フラグ型.無効,
    バラ管理フラグ: バラ管理フラグ型.箱管理,
    有効期限管理フラグ: 有効期限管理フラグ型.管理しない,
    棚卸有効期限非表示フラグ: 棚卸有効期限非表示フラグ型.表示,
    HT移動一括取込フラグ: HT移動一括取込フラグ型.即時,
    HT払出一括取込フラグ: HT払出一括取込フラグ型.即時,
    外部連携利用フラグ: 外部連携利用フラグ型.利用しない,
    譲渡譲受利用フラグ: 譲渡譲受利用フラグ型.利用しない,
    独自コード利用フラグ: 独自コード利用フラグ型.利用しない,
    独自区分利用フラグ: 独自区分利用フラグ型.利用しない,
    独自仕様区分: null,
    特別メニュー区分一覧: [],
  };
  private 連絡事項表示フラグ: boolean = false;
  private 選択メニュー: string = '発注';

  @Mutation
  public account(ログインアカウント: ログインアカウント型) {
    this.ログインアカウント = ログインアカウント;
  }

  @Mutation
  public clear() {
    this.ログインアカウント = {
      医療機関コード: '',
      部署コード: '',
      部署名: '',
      利用者コード: '',
      氏名: '',
      権限レベル区分: 権限レベル区分型.利用者,
      システム利用区分: システム利用区分型.発注のみ,
      備蓄品採用フラグ: 備蓄品採用フラグ型.無効,
      発注書自動表示フラグ: 発注書自動表示フラグ型.無効,
      バラ管理フラグ: バラ管理フラグ型.箱管理,
      有効期限管理フラグ: 有効期限管理フラグ型.管理しない,
      棚卸有効期限非表示フラグ: 棚卸有効期限非表示フラグ型.表示,
      HT移動一括取込フラグ: HT移動一括取込フラグ型.即時,
      HT払出一括取込フラグ: HT払出一括取込フラグ型.即時,
      外部連携利用フラグ: 外部連携利用フラグ型.利用しない,
      譲渡譲受利用フラグ: 譲渡譲受利用フラグ型.利用しない,
      独自コード利用フラグ: 独自コード利用フラグ型.利用しない,
      独自区分利用フラグ: 独自区分利用フラグ型.利用しない,
      独自仕様区分: null,
      特別メニュー区分一覧: [],
    };
    this.連絡事項表示フラグ = false;
    this.選択メニュー = '発注';
  }

  @Mutation
  public 連絡事項表示フラグ更新(連絡事項表示フラグ: boolean) {
    this.連絡事項表示フラグ = 連絡事項表示フラグ;
  }

  @Mutation
  public 表示メニュー更新(選択メニュー: string) {
    this.選択メニュー = 選択メニュー;
  }

  @Action({rawError: true})
  public async 取得する(): Promise<void> {
    const ログインアカウント = await api.ログインアカウントを取得する();
    this.account(ログインアカウント);
  }

  @Action
  public ログインアカウントを戻す(ログインアカウント: ログインアカウント型): void {
    this.account(ログインアカウント);
  }

  @Action({})
  public 連絡事項表示トグル(): void {
    this.連絡事項表示フラグ更新(!this.連絡事項表示フラグ);
  }

  @Action({})
  public 表示メニューを設定する(表示メニュー: string): void {
    this.表示メニュー更新(表示メニュー);
  }

  @Action({})
  public クリアする(): void {
    this.clear();
  }

  get 部署コードを取得する(): string {
    return this.ログインアカウント.部署コード;
  }

  get 部署名を取得する(): string {
    return this.ログインアカウント.部署名;
  }

  get 利用者コードを取得する(): string {
    return this.ログインアカウント.利用者コード;
  }

  get 氏名を取得する(): string {
    return this.ログインアカウント.氏名;
  }

  get マスターである(): boolean {
    return 権限レベル区分型.マスター === this.ログインアカウント.権限レベル区分;
  }

  get 管理者である(): boolean {
    if (権限レベル区分型.マスター === this.ログインアカウント.権限レベル区分) {
      return true;
    }
    return 権限レベル区分型.管理者 === this.ログインアカウント.権限レベル区分;
  }

  get システム利用区分が発注と在庫管理である(): boolean {
    return システム利用区分型.発注と在庫管理 === this.ログインアカウント.システム利用区分;
  }

  get 備蓄品の発注が有効である(): boolean {
    return 備蓄品採用フラグ型.有効 === this.ログインアカウント.備蓄品採用フラグ;
  }

  get 備蓄品の発注が無効である(): boolean {
    return 備蓄品採用フラグ型.無効 === this.ログインアカウント.備蓄品採用フラグ;
  }

  get 発注書の自動表示が有効である(): boolean {
    return 発注書自動表示フラグ型.有効 === this.ログインアカウント.発注書自動表示フラグ;
  }

  get 発注書の自動表示が無効である(): boolean {
    return 発注書自動表示フラグ型.無効 === this.ログインアカウント.発注書自動表示フラグ;
  }

  get 箱管理である(): boolean {
    return バラ管理フラグ型.箱管理 === this.ログインアカウント.バラ管理フラグ;
  }

  get バラ管理である(): boolean {
    return バラ管理フラグ型.バラ管理 === this.ログインアカウント.バラ管理フラグ;
  }

  get 外部連携を利用する(): boolean {
    return 外部連携利用フラグ型.利用する === this.ログインアカウント.外部連携利用フラグ;
  }

  get 譲渡譲受を利用する(): boolean {
    return 譲渡譲受利用フラグ型.利用する === this.ログインアカウント.譲渡譲受利用フラグ;
  }

  get 有効期限管理をしない(): boolean {
    return 有効期限管理フラグ型.管理しない === this.ログインアカウント.有効期限管理フラグ;
  }

  get 有効期限管理をする(): boolean {
    return 有効期限管理フラグ型.管理する === this.ログインアカウント.有効期限管理フラグ;
  }

  get 棚卸有効期限を表示する(): boolean {
    return 棚卸有効期限非表示フラグ型.表示 === this.ログインアカウント.棚卸有効期限非表示フラグ;
  }

  get 棚卸有効期限を表示しない(): boolean {
    return 棚卸有効期限非表示フラグ型.非表示 === this.ログインアカウント.棚卸有効期限非表示フラグ;
  }

  get HT移動一括取込する(): boolean {
    return HT移動一括取込フラグ型.一括取込 === this.ログインアカウント.HT移動一括取込フラグ;
  }

  get HT払出一括取込する(): boolean {
    return HT払出一括取込フラグ型.一括取込 === this.ログインアカウント.HT払出一括取込フラグ;
  }

  get 連絡事項表示フラグを取得する(): boolean {
    return this.連絡事項表示フラグ;
  }

  get 選択メニューを取得する(): string {
    return this.選択メニュー;
  }

  get 医療機関コード(): string {
    return this.ログインアカウント.医療機関コード;
  }

  get 特別メニューが有効である(): boolean {
    return this.外部連携を利用する ||
      this.ログインアカウント.特別メニュー区分一覧.length !== 0;
  }

  get 渓仁会仕様である(): boolean {
    return this.ログインアカウント.独自仕様区分 === '渓仁会仕様';
  }

  get 函館五稜郭病院仕様である(): boolean {
    return this.ログインアカウント.独自仕様区分 === '函館五稜郭病院仕様';
  }

  get 定数在庫表_函館五稜郭病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('定数在庫表_函館五稜郭病院');
  }

  get 薬品受払表_函館五稜郭病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('薬品受払表_函館五稜郭病院');
  }

  get 納品データ出力_渓仁会が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('納品データ出力_渓仁会');
  }

  get 入出庫集計表_渓仁会が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('入出庫集計表_渓仁会');
  }

  get 部署別出庫実績集計表_渓仁会が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('部署別出庫実績集計表_渓仁会');
  }

  get 部署別在庫集計表_渓仁会が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('部署別在庫集計表_渓仁会');
  }

  get 在庫集計表_札幌南三条病院_札幌南一条病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('在庫集計表_札幌南三条病院_札幌南一条病院');
  }

  get 納品加重明細表_札幌禎心会病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('納品加重明細表_札幌禎心会病院');
  }

  get 払出一覧_札幌しらかば台病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('払出一覧_札幌しらかば台病院');
  }

  get トーショー納入明細出力_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('トーショー納入明細出力_小樽市立病院');
  }

  get 日付別発注実績明細表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('日付別発注実績明細表_小樽市立病院');
  }

  get 納入実績明細表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('納入実績明細表_小樽市立病院');
  }

  get 納入実績集計表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('納入実績集計表_小樽市立病院');
  }

  get 出庫実績集計表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('出庫実績集計表_小樽市立病院');
  }

  get 薬品別受払年報_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('薬品別受払年報_小樽市立病院');
  }

  get メーカー別受入分析表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('メーカー別受入分析表_小樽市立病院');
  }

  get 薬品別受入分析表_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('薬品別受入分析表_小樽市立病院');
  }

  get 期限切れ_破棄破損入力_小樽市立病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('期限切れ_破棄破損入力_小樽市立病院');
  }

  get 個別帳票出力_新さっぽろ脳神経外科病院が有効である(): boolean {
    return this.ログインアカウント.特別メニュー区分一覧.includes('個別帳票出力_新さっぽろ脳神経外科病院');
  }

  get 独自コード利用が有効である(): boolean {
    return this.ログインアカウント.独自コード利用フラグ === 独自コード利用フラグ型.利用する;
  }

  get 独自区分利用が有効である(): boolean {
    return this.ログインアカウント.独自区分利用フラグ === 独自区分利用フラグ型.利用する;
  }

  get 外部連携利用が有効である(): boolean {
    return this.ログインアカウント.外部連携利用フラグ === 外部連携利用フラグ型.利用する;
  }
}

export const loginModule = getModule(Login);
